module.exports = __webpack_public_path__ + "static/media/swinging_clevis.74728f49.webp";